import useUserCurriculumsQuery from "../useUserCurriculumsQuery";

export default function useUserDefaultCurriculumQuery(options = {}) {
  const {
    userCurriculums,
    isUserCurriculumsLoading,
    userCurriculumsError,
  } = useUserCurriculumsQuery(options);
  const userDefaultCurriculum = userCurriculums?.[0];

  return {
    userDefaultCurriculum,
    isUserDefaultCurriculumLoading: isUserCurriculumsLoading,
    userDefaultCurriculumError: userCurriculumsError,
  };
}
